import { UniversColored } from '../../assets/univers/colored'
import { UniversLightOrange } from '../../assets/univers/light-orange'
import { UniversDarkOrange } from '../../assets/univers/dark-orange'
import { UniversLightBlue } from '../../assets/univers/light-blue'
import { UniversDarkBlue } from '../../assets/univers/dark-blue'
import { UniversColoredSymbol } from '../../assets/univers/colored-symbol'
import { UniversWhiteSymbol } from '../../assets/univers/white-symbol'
import { UniversBlackSymbol } from '../../assets/univers/black-symbol'
import { LogoWhithoutVariant } from '../without-variants'

export const logos = {
  white: {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  black: {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  colored: {
    large: <UniversColored width={149} height={48} />,
    huge: <UniversColored width={249} height={64} />,
    enormous: <UniversColored width={349} height={80} />,
  },
  yellow: {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'light-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'light-orange': {
    large: <UniversLightOrange width={149} height={48} />,
    huge: <UniversLightOrange width={249} height={64} />,
    enormous: <UniversLightOrange width={349} height={80} />,
  },
  'dark-orange': {
    large: <UniversDarkOrange width={149} height={48} />,
    huge: <UniversDarkOrange width={249} height={64} />,
    enormous: <UniversDarkOrange width={349} height={80} />,
  },
  'light-blue': {
    large: <UniversLightBlue width={149} height={48} />,
    huge: <UniversLightBlue width={249} height={64} />,
    enormous: <UniversLightBlue width={349} height={80} />,
  },
  'dark-blue': {
    large: <UniversDarkBlue width={149} height={48} />,
    huge: <UniversDarkBlue width={249} height={64} />,
    enormous: <UniversDarkBlue width={349} height={80} />,
  },
}

export const symbols = {
  white: {
    large: <UniversWhiteSymbol width={24} height={48} />,
    huge: <UniversWhiteSymbol width={40} height={64} />,
    enormous: <UniversWhiteSymbol width={56} height={80} />,
  },
  black: {
    large: <UniversBlackSymbol width={24} height={48} />,
    huge: <UniversBlackSymbol width={40} height={64} />,
    enormous: <UniversBlackSymbol width={56} height={80} />,
  },
  colored: {
    large: <UniversColoredSymbol width={24} height={48} />,
    huge: <UniversColoredSymbol width={40} height={64} />,
    enormous: <UniversColoredSymbol width={56} height={80} />,
  },
  yellow: {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'light-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'light-orange': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-orange': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'light-blue': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-blue': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
}
